module.exports = __webpack_public_path__ + "img/Kazakhstan.4ec56cea.gif";